/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for MailTemplate controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetMailTemplateByIdResponse, UpdateMailTemplateRequest, GetMailTemplatesResponse, CreateMailTemplateRequest, CreateMailTemplateResponse } from "../models";

@Injectable({ providedIn: "root" })
export class MailTemplateService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getMailTemplateById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetMailTemplateByIdResponse>;
    getMailTemplateById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetMailTemplateByIdResponse>>;
    getMailTemplateById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetMailTemplateByIdResponse>>;
    getMailTemplateById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/MailTemplate/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateMailTemplate(id: number, updateMailTemplateRequest: UpdateMailTemplateRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateMailTemplate(id: number, updateMailTemplateRequest: UpdateMailTemplateRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateMailTemplate(id: number, updateMailTemplateRequest: UpdateMailTemplateRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateMailTemplate(id: number, updateMailTemplateRequest: UpdateMailTemplateRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/MailTemplate/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateMailTemplateRequest, requestOptions);
    }

    deleteMailTemplate(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteMailTemplate(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteMailTemplate(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteMailTemplate(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/MailTemplate/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getMailTemplates(searchTerm?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetMailTemplatesResponse>;
    getMailTemplates(searchTerm?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetMailTemplatesResponse>>;
    getMailTemplates(searchTerm?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetMailTemplatesResponse>>;
    getMailTemplates(searchTerm?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/MailTemplate`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createMailTemplate(createMailTemplateRequest: CreateMailTemplateRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateMailTemplateResponse>;
    createMailTemplate(createMailTemplateRequest: CreateMailTemplateRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateMailTemplateResponse>>;
    createMailTemplate(createMailTemplateRequest: CreateMailTemplateRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateMailTemplateResponse>>;
    createMailTemplate(createMailTemplateRequest: CreateMailTemplateRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/MailTemplate`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createMailTemplateRequest, requestOptions);
    }
}
